import { Box, Button, useTheme } from '@chakra-ui/react';
import { FC } from 'react';
import { ChakraButtonProps } from './types';

const ButtonCJ: FC<ChakraButtonProps> = ({
  backgroundColor: backgroundColorProp,
  dataTestId,
  isDisabled,
  ...props
}) => {
  const chakraTheme = useTheme();
  const { gold, lightGrey, white } = chakraTheme.colors;
  const backgroundColor = isDisabled ? lightGrey : backgroundColorProp || gold;

  return (
    <Box display='flex'>
      <Button
        backgroundColor={backgroundColor}
        fontFamily={chakraTheme.fonts.semiBold}
        display='flex'
        flexDirection='row'
        justifyContent='center'
        alignItems='center'
        width='105px'
        height='29px'
        border='none'
        borderRadius='3px'
        color={white}
        fontSize='14px'
        lineHeight='19px'
        transition='none'
        _hover={{ backgroundColor }}
        _focus={{ backgroundColor }}
        _active={{ backgroundColor }}
        isDisabled={isDisabled}
        opacity={isDisabled ? 0.5 : 1.0}
        cursor={isDisabled ? 'not-allowed' : 'pointer'}
        data-testid={dataTestId || 'cj-button'}
        {...props}
      />
    </Box>
  );
};

export default ButtonCJ;
